import {BreakoutData, BreakoutModel} from 'models/program/BreakoutModel'
import {
	ProgramModel,
	ProgramNavigationItem,
	ProgramSchedule
} from 'models/program/ProgramModel'
import {SequenceData, SequenceModel} from 'models/program/SequenceModel'
import {SessionData, SessionModel} from 'models/program/SessionModel'
import {SummitType} from 'types'
import {Memoize} from 'util/memoize'

export type ProgramdayData = {
	path: string
	url: string
	title: string
	subtitle: string
	theme?: SummitType
	children: Array<SequenceData | BreakoutData | SessionData>
}

export class ProgramdayModel {
	program: ProgramModel
	data: ProgramdayData

	constructor(program: ProgramModel, data: ProgramdayData) {
		this.program = program
		this.data = data
	}

	@Memoize()
	get day(): ProgramdayModel {
		return this
	}

	@Memoize()
	get url(): string {
		return this.data.url
	}

	@Memoize()
	get path(): string {
		return this.data.path
	}

	@Memoize()
	get schedule(): ProgramSchedule {
		return this.data.children.map(data => {
			switch (data.channel) {
				case 'sequence':
					return new SequenceModel(this, data)
				case 'breakout':
					return new BreakoutModel(this, data)
				case 'session':
					return new SessionModel(this, data)
			}
		})
	}

	@Memoize()
	get title(): string {
		return this.data.title
	}

	@Memoize()
	get subtitle(): string {
		return this.data.subtitle
	}

	@Memoize()
	get theme(): SummitType {
		return this.data.theme
	}
}
